import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=2d6d9c92&scoped=true&"
import script from "./selector.vue?vue&type=script&lang=js&"
export * from "./selector.vue?vue&type=script&lang=js&"
import style0 from "./selector.vue?vue&type=style&index=0&id=2d6d9c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d9c92",
  null
  
)

export default component.exports